:host {
  display: block;
  top: 0;
}

.info-tag-container {
  top: 0;
  left: 0;
  background-color: white;
}

.info-tag-title {
  border: solid 1px #ce2a3e;
  background-color: #ce2a3e;
  padding: 2px 14px;
  color: white;
  border-radius: 8px 8px 0 0;
  font-weight: bold;
  font-size: 12px;
  width: max-content;
}

.info-tag-content {
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  gap: 12px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  background-color: white;
  border-radius: 0 8px 8px;
  border: solid 1px #ce2a3e;
  color: var(--neutral-00);
}

a {
  font-size: 14px;
}
